import { render, staticRenderFns } from "./DataSimulationSection.vue?vue&type=template&id=190c2efc&scoped=true&"
import script from "./DataSimulationSection.vue?vue&type=script&lang=js&"
export * from "./DataSimulationSection.vue?vue&type=script&lang=js&"
import style0 from "./DataSimulationSection.vue?vue&type=style&index=0&id=190c2efc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190c2efc",
  null
  
)

export default component.exports